import SanityNavItem from "@/contents/atoms/SanityNavItem"
import SanityImageField from "@/integrations/sanity/components/SanityImageField"
import Menu from "@/ui/layout/Menu"

export interface SanityMenuProps {
  open: boolean
  onClose?: () => void
  content: any
  locale: string
}

const SanityMenu = ({ open, onClose, content }: SanityMenuProps) => {
  return (
    <Menu
      open={open}
      onClose={() => onClose?.()}
      logo={
        <SanityImageField
          className="max-w-[200px]"
          width={200}
          height={200}
          asset={content.logo}
        />
      }
      menuItems={
        content.menuItems?.map((item: any) => ({
          item: <SanityNavItem item={item} onClick={onClose} />,
        })) ?? []
      }
      bottomContents={{
        email: content.email,
      }}
    />
  )
}

export default SanityMenu
